var render, staticRenderFns
import script from "./devicelist.vue?vue&type=script&lang=js&"
export * from "./devicelist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfcc285",
  null
  
)

export default component.exports